var _a, _b;
export const IS_RESULT = Symbol('Result');
class Ok {
    constructor(value) {
        this.value = value;
        this[_a] = true;
    }
    isOk() {
        return true;
    }
    isErr() {
        return false;
    }
    mapOk(map) {
        return ok(map(this.value));
    }
    async mapOkAsync(map) {
        return ok(await map(this.value));
    }
    into() {
        return this;
    }
    is(...typeAssertionFns) {
        return typeAssertionFns.some(typeAssertionFn => typeAssertionFn(this.value));
    }
    isNot(...typeAssertionFns) {
        return typeAssertionFns.every(typeAssertionFn => !typeAssertionFn(this.value));
    }
}
_a = IS_RESULT;
class Err {
    // eslint-disable-next-line node/handle-callback-err
    constructor(error) {
        this.error = error;
        this[_b] = true;
    }
    isOk() {
        return false;
    }
    isErr() {
        return true;
    }
    mapOk(map) {
        return err(this.error);
    }
    async mapOkAsync(map) {
        return err(this.error);
    }
    into() {
        return this;
    }
    isInstanceOf(...constructors) {
        return constructors.some(constructor => this.error instanceof constructor);
    }
}
_b = IS_RESULT;
export function isResult(obj) {
    return typeof obj === 'object' && obj !== null && obj[IS_RESULT] === true;
}
export function ok(value) {
    if (isResult(value))
        return value;
    return new Ok(value);
}
export function err(error) {
    if (isResult(error))
        return error;
    return new Err(error);
}
export function isAllOk(value) {
    return !value.some(val => val.isErr());
}
export function isAllErr(value) {
    return !value.some(val => val.isOk());
}
//# sourceMappingURL=index.js.map